import React from 'react';
import ClearRoundedIcon from '@material-ui/icons/ClearRounded';

/**
 * Description - Icon to show false value in table
 */
const TableFalseValueComponent = () => <ClearRoundedIcon color="error" />;

export default TableFalseValueComponent;
